import { FC, ReactElement } from 'react'
import GoogleMapReact from 'google-maps-react-markers'
import conf from '~/app/conf'
import type { MapOptions, Props } from 'google-map-react'

/**
 * GoogleMap component
 * author: soojin.oh
 */

// type definitions
type GoogleMapProps = {
  zoom: number
  latitude: number
  longitude: number
  markers?: Array<ReactElement<{ lat: number; lng: number }>>
  options?: MapOptions
  onGoogleApiLoaded?: Props['onGoogleApiLoaded']
}

export type GoogleMapRef = {
  setCenter: (center: { lat: number; lng: number }) => void
}

/**
 * @summary 구글 맵 컴포넌트
 * @param latitude - 위도
 * @param longitude - 경도
 * @param zoom - 줌 레벨
 * @param markers - 마커
 * @param options - 옵션
 * @param onGoogleApiLoaded - 구글 맵 로드 콜백
 * @description
 *  - google-map-react 라이브러리에서 React 18 호환이 좋지 않아 마커 사용시 flickering 이 발생함
 *  - https://github.com/google-map-react/google-map-react/issues/1143
 *  - 위 이슈로 인해 임시 google-map-react-markers 라이브러리를 사용함
 */
const GoogleMap: FC<GoogleMapProps> = function ({
  latitude,
  longitude,
  zoom,
  markers,
  options,
  onGoogleApiLoaded,
}) {
  if (!!latitude && !!longitude) {
    return (
      <GoogleMapReact
        apiKey={conf.google.maps.key}
        defaultCenter={{ lat: latitude, lng: longitude }}
        defaultZoom={zoom}
        options={options}
        externalApiParams={{ language: 'ko', region: 'KR' }}
        onGoogleApiLoaded={onGoogleApiLoaded}
      >
        {markers}
      </GoogleMapReact>
    )
  }
  return null
}

export default GoogleMap
